import { render } from "./Ideas.vue?vue&type=template&id=2b05d776&ts=true"
import script from "./Ideas.vue?vue&type=script&lang=ts"
export * from "./Ideas.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kanbios/echo-v2/demo-front-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__